import { on } from 'delegated-events';
import invisibleFocus from '../../../javascripts/utils/invisibleFocus';
import moveFocus from '../../../javascripts/utils/moveFocus';
import abort from '../../../javascripts/utils/abort';

on('click', '.mail-preview__toggle', (event) => {
  const { currentTarget: $toggle } = event;

  const bodyId = $toggle.getAttribute('data-controls') ?? abort();
  const $body = document.getElementById(bodyId) ?? abort();
  const $mailPreview = $body.closest('.mail-preview') ?? abort();

  event.preventDefault();
  invisibleFocus($toggle);

  const isOpen = $mailPreview.getAttribute('data-expanded') === 'true';
  $mailPreview.setAttribute('data-expanded', isOpen ? 'false' : 'true');

  if (!isOpen) {
    moveFocus($body);
  }
});
